<template>
  <Teleport to="#lostpasswordform">
    <div id="reset-options">
      <div id="otp-option">
        <p class="spaced"> {{ strings['OtpOpt'] }} </p>
        <input type="button" :value="strings['OtpButton']" id="otp-button"
               class="button button-primary button-large" @click="otpChosen">
      </div>
      <br class="clearField">
      <h2 id="or-text"> {{ strings['Or'] }} </h2>
      <div id="link-option" class="spaced">
        <p class="spaced"> {{ strings['LinkOpt'] }} </p>
      </div>
    </div>
    <otp-options
        v-if="OTP"
        @back="hideOtp"
        :strings = strings
        :sms-num = smsNum
        :email-add = emailAdd
    />
  </Teleport>
</template>

<script setup>
import $ from 'jquery';
import {ref, onMounted} from "vue";
import OtpOptions from "./otpOption";

const strings = window.OtpOptionStrings;
let OTP = ref(false);
let smsNum = '';
let emailAdd = '';

function otpChosen() {
  $(document.body).css({'cursor' : 'wait'});
  $('#otp-button').prop("disabled", true);

  // if user info is found, fill in labels with info from ajax
  $.post(strings['AjaxUrl'], {
    action: 'get-otp-channels',
    usernameOrEmail: $('#user_login').val()
  }, function(res) {
    let data = $.parseJSON(res);
    smsNum = data.SMSChannel;
    emailAdd = data.EmailChannel;
    if (smsNum !== '' || emailAdd !== '') {
      showOtp();
    }

    $(document.body).css({'cursor' : 'default'});
    $('#otp-button').prop("disabled", false);
  });
}

function showOtp() {
  $('.message').fadeOut();
  $('#lostpasswordform').children().each(function() {
    $(this).fadeOut();
  }).promise().done(function() {
    OTP.value = true
  });
}

function hideOtp() {
  OTP.value = false;
  $('#otp-notice').fadeOut();
  $('.notice-info').fadeIn();
  $('#lostpasswordform').children().fadeIn();
}

onMounted(function() {
  // modify form to fit added OTP option
  $('.notice-info').find('p')[0].innerHTML = strings['Notice'];
  let submitButton = $('#wp-submit');
  $('#link-option').append(submitButton);
  submitButton.addClass('spaced');
  submitButton.css("float", "none");
  submitButton.attr('value', strings['LinkButton']);
});
</script>

<style scoped>
.spaced {
  margin-top: 10px !important;
  margin-bottom: 5px !important;
}

#or-text {
  font-weight: bold;
  margin-bottom: 20px;
}

.clearField {
  clear: both;
}

#otp-button {
  float: none;
}

#reset-options {
  text-align: center;
}
</style>